import { defineMessages } from 'react-intl-next';

export const messages: {
    infoIconLabelText: {
        defaultMessage: string;
        description: string;
        id: string;
    }; segmentationAllDropDownItemLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; segmentationEachDropDownItemLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; segmentationNoneDropDownItemLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; segmentationTargetLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	segmentationTargetLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-text.v2.label',
		defaultMessage: 'Target audience',
		description:
			'A visible text label for the segmentation target field of the link cards config panel',
	},
	segmentationNoneDropDownItemLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.v2.item.no-segmentation.label',
		defaultMessage: 'None',
		description:
			'A visible label for the select option/selection/item that turns audience segmentation off',
	},
	segmentationAllDropDownItemLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.all-cards.label',
		defaultMessage: 'All cards',
		description:
			'A visible label for the select option/selection/item to change segmentation target to all cards',
	},
	segmentationEachDropDownItemLabel: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.segmentation-target-field.drop-down.item.v2.each-card.label',
		defaultMessage: 'Each card',
		description:
			'A visible label for the select option/selection/item to change segmentation target to each card',
	},
	infoIconLabelText: {
		id: 'company-hub.company-hub-common.link-cards.link-cards-config-panel.type-field.toggle.info-icon-label-v2',
		defaultMessage: 'Choose which Confluence user groups will see your cards',
		description: 'A visible label for the information icon',
	},
});
